import styles from "./articleListingPanel.module.scss";
import Col3LSM from "./col3LSM";
import Col3SML from "./col3SML";
import "./articleListingLayouts.scss";
import Col2FiftyFifty from "./col2FiftyFifty";
import { useEffect, useMemo, useState } from "react";
import Pagination from "../../../components/pagination/Pagination";
import { useStoryblokArticles } from "../../../hooks/useStoryblokArticles";

let PageSize = 10;

function ArticleListingPanel({ blok, keyProp, id, story_language }) {
  const filter = useMemo(()=>{
    var temp = {};
    if(blok.category){
      temp.category = blok.category;
    }
    if(blok.type){
      temp.article_type = blok.type
    }
    if(blok.tag){
      temp.tag_list = blok.tag.article_tag
    }
    return temp
  },[blok])
  const [allArticles] = useStoryblokArticles(filter,null,null,story_language);
  const [currentPage, SetCurrentPage] = useState(1);
  const [articles, setArticles] = useState([]);
  var pageParams = new URLSearchParams(document.location.search);
  useEffect(()=>{
    if(blok.articles){
      setArticles(blok.articles);
    }else{
      setArticles(allArticles);
    }
    if(pageParams.get("page")){
      SetCurrentPage(pageParams.get("page"));
    }
  },[blok.articles, pageParams]);

  var paginate = true

  if(blok.paginate){
    paginate = blok.paginate;
  }

  const currentArticleData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    if(articles){
      return articles.slice(firstPageIndex, lastPageIndex);
    }
    return [];
  }, [currentPage, articles]);

  var useArticles = articles
  if(paginate){
    useArticles = currentArticleData;
  }

  var layout = "col1-inline";
  if (blok.layout) {
    layout = blok.layout;
  }

  var chunkedData = [];

  //TEMP 2 COL TEST
  if (layout === "col2") {
    articles = useArticles.slice(0, 4);
    chunkedData.push(articles.slice(0, 1));
    chunkedData.push(articles.slice(1));
  } else {
    //END TEMP
    var colCount = layout.match(/\d/gm)[0];
    var totalCount = useArticles.length;
    var chunkSize = totalCount / colCount;

    for (let i = 0; i < useArticles.length; i += chunkSize) {
      const chunk = useArticles.slice(i, i + chunkSize);
      chunkedData.push({ chunk });
    }
  } //TEMP

  return (
    <div className={`${styles.articleListingWrapper} view`} id={id ? id: null} style={layout === "col2-ls" ? {maxWidth: "846px", marginLeft: "0"} : null} key={keyProp}>
      {blok.showHeader && blok.headline !== "" && blok.headline !== null ? <div className={`${styles.listingHeadline} listingHeadline`}><h2>{blok.headline}</h2></div> : null}
      <div className={`${styles.articleListGrid} ${layout}`}>
        {
          getListingLayout(layout, chunkedData)
        }
        {paginate ? <Pagination className="pagination-bar" currentPage={currentPage} totalCount={articles.length} pageSize={10} onPageChange={(page) => {
          const url = new URL(window.location);
          if(page === 1){
            url.searchParams.delete('page')
          }else{
            url.searchParams.set('page', page);
          }
          window.history.pushState({}, '', url)
          SetCurrentPage(page)
          if((currentPage && currentPage > 1) && (!page|| page === 1)){
            document.getElementById("featured").classList.toggle("show");
          }
          if((!currentPage || currentPage ===1) && (page > 1)){
           document.getElementById("featured").classList.toggle("show");
          }
      }
        } />: null}
      </div>
    </div>
  );
}

function getListingLayout(layout, chunkedData) {
  switch (layout) {
    case "col2":
      return <Col2FiftyFifty articles={chunkedData} />;
    case "col3-sml":
      return <Col3SML articles={chunkedData} />;
    case "col3-lsm":
      return <Col3LSM articles={chunkedData} />;
    default:
      return "Layout Unavalible"; 
  }
}

export default ArticleListingPanel;
